export default __webpack_public_path__ + "static/media/tukchannels.1f98b306.mp4";